export default function (window, requirejs, isSuspectedBot, prefetch, experiment) {
  const { location = {} } = window
  const { href = '' } = location

  let delayedErrors = []
  function sendErrorOrQueue(...args) {
    const { wixBiSession } = window
    if (wixBiSession && wixBiSession.sendError) {
      wixBiSession.sendError(...args)
    } else {
      delayedErrors.push(args)
    }
  }

  const { performance = {} } = window

  function instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo) {
    wixBiSession.initialTimestamp = wixBiSession.initialTimestamp || wixBiSession.mainLoaded
    wixBiSession.random = Math.random()

    const sampleRatioState = queryUtil.getParameterByName('sampleratio')
    const rendererModel = siteModel.rendererModel || window.rendererModel
    const { premiumFeatures, siteInfo } = rendererModel
    const isPremium = !!premiumFeatures && premiumFeatures.indexOf('HasDomain') !== -1
    const base = (serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '')

    function recordEt(et) {
      wixBiSession.et = et
      if (performance.mark) {
        performance.mark(`beat ${et}`)
      }
    }
    wixBiSession.beat = recordEt

    const param = (name, value) => `${name}=${value}`
    const params = (pairs, p = param) => Object.keys(pairs).map(value => p(value, pairs[value])).join('&')

    const biBool = bool => Number(Boolean(bool))

    function prepareMessage(evid, src, { omit = {}, map, pairs = {} }) {
      pairs.evid = evid
      pairs.src = src

      if (!omit.pn) {
        pairs.pn = 1
      }
      if (!omit.isp) {
        pairs.isp = biBool(isPremium)
      }
      if (!omit.url) {
        const url = href.replace(/^[^:]+:\/\/(www\.)?/i, '')
        pairs.url = encodeURIComponent(url.substring(0, 256))
      }

      if (!omit.v) {
        pairs.v = siteModel.baseVersion || 'unknown'
      }
      if (!omit.majorVer) {
        pairs.majorVer = window.clientSideRender ? 3 : 4
      }
      if (!omit.ver && window.santaBase) {
        const sourceMatches = window.santaBase.match(/([\d\.]+)\/?$/)
        pairs.ver = sourceMatches && sourceMatches[1] || ''
      }

      if (!omit.dc && serviceTopology) {
        const serverName = serviceTopology.serverName
        if (typeof serverName === 'string') {
          const parts = serverName.split('.')
          if (parts.length > 1) {
            pairs.dc = parts[1]
          }
        }
      }

      if (siteInfo && siteInfo.siteId) {
        pairs.sid = siteInfo.siteId
      }
      if (rendererModel.metaSiteId) {
        pairs.msid = rendererModel.metaSiteId
      }

      const siteHeader = siteModel.siteHeader || window.siteHeader
      if (!omit.uuid && siteHeader && siteHeader.userId) {
        pairs.uuid = siteHeader.userId
      }
      const { publicModel } = siteModel
      if (!omit.tsp && publicModel && publicModel.timeSincePublish) {
        pairs.tsp = publicModel.timeSincePublish
      }
      if (wixBiSession.viewerSessionId) {
        pairs.vsi = wixBiSession.viewerSessionId
      }

      if (!omit.ts && wixBiSession.initialTimestamp) {
        pairs.ts = Date.now() - wixBiSession.initialTimestamp
      }

      const _param = map ? (name, value) => param(map[name] || name, value) : param
      return params(pairs, _param)
    }

    function sendBI(endpoint, evid, code, options = {}) {
      let src = `${base}/${endpoint}?c=${Date.now()}&`
      src += prepareMessage(evid, code, options)
      if (options.extra) {
        src += options.extra
      }
      (new window.Image()).src = src
    }

    wixBiSession.sendBI = function (endpoint, evid, code, extra, sampleRatio) {
      if (!sampleRatio || Math.floor(wixBiSession.random * sampleRatio) === 0) {
        sendBI(endpoint, evid, code, {
          omit: {
            pn: true,
            isp: true,
            ts: true,
            url: true,
            v: true,
            ver: true
          },
          map: {
            sid: 'did',
            dc: 'server',
            uuid: 'uid'
          },
          pairs: extra
        })
      }
    }

    let sendError = (name, errc, sev = 40, ...args) => { // eslint-disable-line func-style
      sendError = () => {} // only report one error per session

      const visitor_id = wixBiSession.viewerSessionId

      let pairs = {
        errn: encodeURIComponent(name),
        errc,
        sev,
        errscp: 'core',
        cat: 2,
        iss: 1,
        et: wixBiSession.et,
        visitor_id
      }

      let total = 0
      pairs = args.reduce((result, arg, index) => {
        if (total + arg.length > 1024) {
          arg = arg.substring(0, Math.max(1024 - total, 32))
        }
        result['p' + (index + 1)] = encodeURIComponent(arg) //eslint-disable-line prefer-template
        total += result.length
        return result
      }, pairs)

      sendBI('trg', 10, 44, {
        omit: {
          pn: true,
          isp: true,
          tsp: true,
          v: true,
          url: true,
          uuid: true
        },
        map: {
          sid: 'did',
          dc: 'server',
          ts: 'response_time'
        },
        pairs
      })
    }
    wixBiSession.sendError = (err, ...args) => sendError(...[err.errorName, err.errorCode, err.severity, ...args])

    delayedErrors.forEach(delayedError => wixBiSession.sendError(...delayedError))
    delayedErrors = null

    // Grow performance resource buffer as required
    const isDebug = queryUtil.getParameterByName('debug')
    if (performance.setResourceTimingBufferSize) {
      if ('onresourcetimingbufferfull' in performance) {
        performance.onresourcetimingbufferfull = (function () {
          let maxSize = 150
          return function () {
            maxSize *= 2
            performance.setResourceTimingBufferSize(maxSize)
          }
        }())
      } else {
        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300)
      }
    }

    const newrelic = window.newrelic
    if (newrelic) {
      const shortUrl = href.replace(/^[^/]*\/\//, '')
      if (newrelic.setPageViewName) {
        newrelic.setPageViewName(shortUrl)
      }
      if (newrelic.setCustomAttribute) {
        newrelic.setCustomAttribute('url', shortUrl)
        if (siteInfo && siteInfo.siteId) {
          newrelic.setCustomAttribute('sid', siteInfo.siteId)
        }
        if (rendererModel.metaSiteId) {
          newrelic.setCustomAttribute('msid', rendererModel.metaSiteId)
        }

        if (experiment) {
          const runningExperiments = experiment.getRunningExperiments()
          if (runningExperiments) {
            const experiments = Object.keys(runningExperiments)
                .filter(experiment.isMultiValueExperimentOpen)
                .map(name => {
                  const value = runningExperiments[name]
                  return value !== 'new' ? `${name}=${value}` : name
                })
                .join('][')
            if (experiments) {
              newrelic.setCustomAttribute('experiments', `[${experiments}]`)
            }
          }
        }

        newrelic.setCustomAttribute('preview', biBool(rendererModel.previewMode))
        newrelic.setCustomAttribute('isPremium', isPremium)
        const siteHeader = siteModel.siteHeader || window.siteHeader
        if (siteHeader && siteHeader.userId) {
          newrelic.setCustomAttribute('uuid', siteHeader.userId)
        }
        const publicModel = siteModel.publicModel
        if (publicModel && publicModel.timeSincePublish) {
          newrelic.setCustomAttribute('timeSincePublish', publicModel.timeSincePublish)
        }
        if (wixBiSession.viewerSessionId) {
          newrelic.setCustomAttribute('vsi', wixBiSession.viewerSessionId)
        }
        newrelic.setCustomAttribute('debug', biBool(isDebug))
      }
    }

    if (prefetch) {
      wixBiSession.sendBI('ugc-viewer', 384, 42)
      return
    }

    if (!wixBiSession.viewerSessionId || rendererModel.previewMode || queryUtil.isParameterTrue('suppressbi')) {
      return
    }

    const isBot = /bot|google|phantom|crawler|spider|robot|crawling|^Mozilla\/4\.0$/i.test(window.navigator.userAgent)
    if (siteInfo.documentType !== 'Template') {
      (function validityBI() {
        let isTop
        try {
          isTop = window.self === window.top
        } catch (e) {
          isTop = false
        }
        if (!isSuspectedBot) {
          try {
            null[0]()
          } catch (e) {
            isSuspectedBot = /ph\x61n\x74om|n\x6fde/i.test(e.stack)
          }
        }
        if (!isTop || isBot || isSuspectedBot) {
          wixBiSession.sendBI('ugc-viewer', 361, 42, {
            top: biBool(isTop),
            bot: biBool(isBot),
            sbot: biBool(isSuspectedBot)
          })
        }
      }())
    }

    if (!window.clientSideRender) {
      window.document.addEventListener('DOMContentLoaded', () => {
        wixBiSession.sendBI('ugc-viewer', 380, 42, { phase_name: 'did_load_dom_content', status: 1 })
      })
    }

    (function performanceBI() {
      const pairs = {}
      const { navigation, timing } = performance
      if (timing) {
        const { domainLookupStart, domainLookupEnd,
            redirectStart, redirectEnd,
            connectStart, connectEnd,
            secureConnectionStart,
            requestStart,
            responseStart, responseEnd } = timing
        const dnsTime = domainLookupEnd - domainLookupStart
        if (dnsTime >= 0) {
          pairs.dns_time = dnsTime
        }
        const redirectTime = redirectEnd - redirectStart
        if (redirectTime >= 0) {
          pairs.redirect_time = redirectTime
        }
        const connectTime = connectEnd - connectStart
        if (connectTime >= 0) {
          pairs.connect_time = connectTime
        }
        if (secureConnectionStart > 0) {
          const sslTime = connectEnd - secureConnectionStart
          pairs.ssl_time = sslTime
        }
        const ttfbTime = responseStart - requestStart
        if (ttfbTime >= 0) {
          pairs.ttfb_time = ttfbTime
        }
        const responseTime = responseEnd - responseStart
        if (responseTime >= 0) {
          pairs.response_time = responseTime
        }
        let loadTime = timing.navigationStart || timing.fetchStart || domainLookupStart || connectStart
        loadTime = wixBiSession.initialTimestamp - loadTime
        if (loadTime >= 0) {
          pairs.load_time = loadTime
        }
        if (pageInfo) {
          pairs.page_id = pageInfo.pageId
        }
        pairs.is_ssl = biBool(location.protocol === 'https:')
      }
      if (navigation) {
        const { redirectCount, type } = navigation
        if (type >= 0) {
          pairs.navigation_type = type
        }
        if (redirectCount >= 0) {
          pairs.redirect_count = redirectCount
        }
      }

      pairs.is_premium = biBool(isPremium)
      pairs.is_wixsite = biBool(siteInfo.documentType === 'WixSite')
      pairs.is_ssr = biBool(!window.clientSideRender)

      wixBiSession.sendBI('ugc-viewer', 351, 42, pairs)
    }())

    if (isDebug && sampleRatioState !== 'force') {
      return
    }

    const siteType = (function () {
      const BEAT_SITE_TYPES = ['No Site Type', 'WixSite', 'UGC', 'Template']
      const documentType = siteInfo.documentType
      const st = BEAT_SITE_TYPES.indexOf(documentType)
      return st !== -1 ? st : documentType
    }())

    wixBiSession.maybeBot = isBot || isSuspectedBot
    wixBiSession.beat = function (et, pid) {
      recordEt(et)
      const pairs = {
        isjp: biBool(wixBiSession.maybeBot),
        et,
        st: siteType
      }
      if (pid) {
        pairs.pid = pid
      }
      sendBI('bt', 3, 29, {
        omit: {
          majorVer: true,
          tsp: true,
          ver: true
        },
        pairs
      })
    }

    const ignoreURLs = [
      /^chrome(\-extension)?\:/, /^file\:/, /^resource\:/, /\.net\//, /\.info\//, /\.ru\//, /google/, /facebook/,
      /dropbox/, /ad\-score/, /drivemac/, /shopping/, /datafast/, /shopcomp/, /vimeo/, /olark/
    ]
    function ignoreError(where) {
      where = where.trim()
      if (!where) {
        return true
      }
      for (let i = 0; i < ignoreURLs.length; ++i) {
        if (ignoreURLs[i].test(where)) {
          return true
        }
      }
      return false
    }

    const { onerror } = window
    window.onerror = function (errorMsg, url, line, column, err) {
      const where = err && typeof err.stack === 'string' ? err.stack : url
      if (!ignoreError(where)) {
        sendError('JAVASCRIPT_ERROR', 111022, 40, errorMsg, where, line, column) // JAVASCRIPT_ERROR from packages/core/src/main/bi/errors.js
      }
      if (onerror) {
        return onerror.apply(this, arguments)
      }
    }

    if (window.console) {
      const { error } = console
      if (error) {
        console.error = function (...args) {
          sendError('CONSOLE_ERROR', 111023, 30, ...args) // CONSOLE_ERROR from packages/core/src/main/bi/errors.js
          return error.apply(this, arguments)
        }
      }
    }

    requirejs.onError = function (err) {
      const modules = (err.requireModules || []).join(';')
      const { message, stack, errn = 'REQUIREJS_ERROR', errc = 111024, severity = 40 } = err
      const where = stack ? '' + stack : '' //eslint-disable-line prefer-template
      sendError(errn, errc, severity, message, modules, where) // REQUIREJS_ERROR from packages/core/src/main/bi/errors.js
    }
  }

  return {
    sendErrorOrQueue,
    instrument
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/instruments.js